
import React from 'react';
import {toStringValueList} from '../../libs/string/toStringValueList.js';
import {useRef} from 'react';

/**
 * @param props.children
 * @param props.disabled
 * @param props.setup
 */
export const PIButton = function (props) {

  const elRef = useRef(null);

  // `elRef.current` will be `null` on the first render and will contain the element
  // on subsequent renders.
  // `props.setup` is called unconditionally in order to allow creating React hooks
  // inside setup.
  // @see https://react.dev/reference/rules/rules-of-hooks#only-call-hooks-at-the-top-level
  props?.setup?.(elRef.current);

  return (<>
    <button
      ref={elRef}
      className={toStringValueList('pi3button', props.className)}
      onClick={(e) => {
        props?.onClick?.(e);
      }}
      disabled={!!props?.disabled}
    >
      {props?.children}
    </button>
  </>);

};
